<ng-container
  *ngIf="{
    product: product$ | async,
    article: article$ | async,
    replacementArticle: replacementArticle$ | async,
    activeTabIndex: activeTabIndex$ | async,
    pdpTypeSkuPicker: pdpTypeSkuPicker$ | async,
    enableSecondaryArticleRowVariant: enableSecondaryArticleRowVariant$ | async,
    catalogProductItemSecondary: catalogProductItemSecondary$ | async,
    tabContainers: tabContainers$ | async,
  } as data"
>
  <div class="container py-max-width" *ngIf="!!data.product">
    <div class="d-flex row no-gutters hide-on-print">
      <div class="col-12" [ngClass]="{ 'mb-2': data.pdpTypeSkuPicker, 'mb-6 mb-md-10': !data.pdpTypeSkuPicker }">
        <py-catalog-breadcrumb
          [ngClass]="{ 'border-bottom': !data.pdpTypeSkuPicker }"
          [showAllCategoriesLink]="true"
          [showBorder]="false"
          [category]="category$ | async"
        ></py-catalog-breadcrumb>
      </div>
    </div>
    <div class="row mb-4 mt-4 mt-md-0" [ngClass]="{ 'mb-md-14': !data.pdpTypeSkuPicker }">
      <div
        class="col-12 image-gallery-holder"
        [ngClass]="{ 'col-md-5': data.pdpTypeSkuPicker, 'col-md-4': !data.pdpTypeSkuPicker }"
      >
        <py-pdp-image-gallery
          [galleryImages]="data.product.images || []"
          [product]="data.product"
          [article]="data.article"
        ></py-pdp-image-gallery>
      </div>
      <div
        class="col-12"
        [ngClass]="{ 'col-md-6 offset-md-1': data.pdpTypeSkuPicker, 'col-md-8 pl-4': !data.pdpTypeSkuPicker }"
        #pdpOverview
      >
        <py-pdp-overview
          [product]="data.product"
          [article]="data.article"
          [replacementArticle]="data.replacementArticle"
          [showReadMore]="data.pdpTypeSkuPicker ? data.activeTabIndex : false"
          (readMore)="scrollToProductInformation($event)"
          [outOfStock]="outOfStock"
          [pdpTypeSkuPicker]="data.pdpTypeSkuPicker"
        ></py-pdp-overview>

        <div *ngIf="data.pdpTypeSkuPicker" class="row no-gutters hide-on-print">
          <div class="col-12 col-lg-11 mt-2 mb-6" *ngIf="data.product.articlePickerAttributes?.length > 0 || !!data.article">
            <py-pdp-sku-picker
              [product]="data.product"
              [article]="data.article"
              [areaOfUseCode]="areaOfUseCode$ | async"
              (setQueryParams)="setQueryParams($event)"
              (articleOutOfStockChange)="setArticleOutOfStock($event)"
            ></py-pdp-sku-picker>
          </div>

          <div *ngIf="!data.product.articlePickerAttributes?.length && !data.article" class="col-12 col-lg-11 mt-4">
            <ng-container *pyPrincipalConfiguration="'enableOrderCardsAdmin'">
              <py-add-to-order-card class="mr-2" [productCode]="data.product.code"></py-add-to-order-card>
            </ng-container>
            <ng-container *pyPrincipalConfiguration="'enableCustomerEditingOfAreaOfUseAdmin'">
              <py-add-to-area-of-use [productCode]="data.product.code"></py-add-to-area-of-use>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12" #productInformation>
        <ng-container *ngIf="data.pdpTypeSkuPicker; else templateNoSKUPicker">
          <py-pdp-sku-picker-tabs
            *ngIf="data.activeTabIndex"
            [product]="data.product"
            [article]="data.article"
            [activeTab]="data.activeTabIndex"
            [tabContainers]="data.tabContainers"
            (selectTab)="activeTabIndex$.next($event)"
          ></py-pdp-sku-picker-tabs>
        </ng-container>
        <ng-template #templateNoSKUPicker>
          <div class="d-flex justify-content-end">
            <ng-container *pyPrincipalConfiguration="'enableOrderCardsAdmin'">
              <py-add-to-order-card class="ml-2" [productCode]="data.product.code"></py-add-to-order-card>
            </ng-container>
            <ng-container *pyPrincipalConfiguration="'enableCustomerEditingOfAreaOfUseAdmin'">
              <py-add-to-area-of-use class="ml-2" [productCode]="data.product.code"></py-add-to-area-of-use>
            </ng-container>
          </div>
          <py-pdp-article-list-tabs
            *ngIf="data.activeTabIndex"
            [product]="data.product"
            [article]="data.article"
            [activeTab]="data.activeTabIndex"
            [tabContainers]="data.tabContainers"
            (selectTab)="activeTabIndex$.next($event)"
          ></py-pdp-article-list-tabs>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="mt-8 mt-md-14 hide-on-print">
    <ng-container *ngIf="relatedArticles$ | async as relatedArticles">
      <div class="cross-selling mb-5" *ngIf="relatedArticles?.length > 0">
        <div class="grey"></div>
        <div class="container py-11">
          <div class="row">
            <div class="col">
              <py-article-carousel
                [carouselItems]="relatedArticles"
                [useDefaultArticleQuantityAndUnit]="true"
                [enableSecondaryArticleRowVariant]="data.enableSecondaryArticleRowVariant"
                [carouselActionMode]="carouselActionModes.ADD_TO_CART_MODE"
              >
                <h2>{{ 'catalog.similarArticles_title' | cxTranslate }}</h2>
              </py-article-carousel>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="cross-selling mb-5" *ngIf="hasRelatedProducts$ | async">
      <div *ngIf="!data.catalogProductItemSecondary" class="grey"></div>
      <div class="container py-11">
        <div class="row">
          <div class="col">
            <py-product-carousel
              [items]="relatedProducts$ | async"
              [title]="'catalog.relatedProducts_title' | cxTranslate"
            ></py-product-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
